import React, { useEffect, useState } from "react";
import {
  // LogIn,
  // Navigation,
  // MapPin,
  CirclePlus,
  CircleMinus,
} from "lucide-react";
import { FaRegCircleUser } from "react-icons/fa6";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assetsWeb/images/logoNew.png";
import cover from "../assetsWeb/images/coverdefault.png";
import noOrderImg from "../assetsWeb/images/Group 178.png";
import { Phone, Mail, Search } from "lucide-react";
import googlee from "../assetsWeb/images/Google_Play_Store_badge_EN.png";
import applee from "../assetsWeb/images/Download_on_the_App_Store_RGB_blk.png";
import defaultimg from "../assetsWeb/images/camera.jpg";
import footerlogo from "../assetsWeb/images/logo-color.png";
import axios from "axios";
import { SERVERADDRESS } from "../constants";
import { setItemData } from "../actions/itemActions";
import { createOrder, setAddress } from "../actions/orderActions";
import SearchedByMap from "../components/SearchedByMap";
// import { getAllItems, setItemData } from "../actions/itemActions";
// import { userLogout } from "../actions/authActions";
// import { getAllStores } from "../actions/storeActions";
// import RestaurantFeed from "./RestaurantFeed";

const HomeStopDetails = () => {
  const orders = useSelector((state) => state.orders);
  const auth = useSelector((state) => state.auth);
  const items = useSelector((state) => state.items);
  const { itemsDetails } = useSelector((state) => state.items);
  const [quantities, setQuantities] = useState({});
  const dispatch = useDispatch();
  const { deliverAddress } = useSelector((state) => state.orders);
  const locationUrl = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Orders");

  const addressSave = (address) => {
    dispatch(setAddress(address));
  };

  const [arr, setArr] = useState([]);
  // console.log(orders, "orders");
  // console.log(items, "items");
  const params = useParams();
  const orderData = async () => {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/store/getStoreById`,
      { _id: params.id }
    );
    setArr(data);
    console.log(data, "datadata");
  };

  useEffect(() => {
    orderData();
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  console.log(arr);

  const updateItemsId = (updatedQuantities) => {
    console.log(updatedQuantities, "updatedItems2");

    const updatedItems = Object.entries(updatedQuantities)
      .map(([id, quantity]) => {
        const item = arr?.allItem?.find((x) => x.id === id);
        return item
          ? {
              itemId: item.id,
              quantity,
              sellPrice: item.sellPrice,
              name: item.name,
              storeId: item.storeId,
            }
          : null;
      })
      .filter(Boolean);
    console.log(updatedItems, "updatedItems");

    // Dispatch or store updated items in cart
    dispatch(setItemData(updatedItems));
  };

  const increaseQuantity = (itemId, name) => {
    setQuantities((prev) => {
      const updated = {
        ...prev,
        [itemId]: (prev[itemId] || 0) + 1,
        name,
      };
      updateItemsId(updated);
      return updated;
    });
  };

  const decreaseQuantity = (itemId, name) => {
    console.log(itemId, name, "chalayyy");

    setQuantities((prev) => {
      if (!prev[itemId] || prev[itemId] <= 1) {
        const updated = { ...prev };
        delete updated[itemId];
        updateItemsId(updated);
        return updated;
      } else {
        const updated = { ...prev, [itemId]: prev[itemId] - 1, name };
        updateItemsId(updated);
        return updated;
      }
    });
  };

  // const handleTabClick = (tab) => {
  //   setActiveTab(tab);
  // };
  const [values, setValues] = useState({
    userId: auth?.user?.id,
    storeId: "",
    itemsId: [],
    // orderNo: "",
    paymentType: "COD",
    // firstName: auth?.user?.firstName,
    // lastName: auth?.user?.lastName,
    // phone: auth?.user?.phone,
    // email: auth?.user?.email,
    address: "",
    totalAmount: "",
    status: "", // valid ?
  });
  useEffect(() => {
    if (values?.address) {
      addressSave(values?.address);
    }
  }, [values?.address]);
  useEffect(() => {
    setValues({
      ...values,
      address: deliverAddress,
    });
  }, [deliverAddress]);
  const checkoutData = {
    userId: auth?.user?.id,
    storeId: params.id,
    itemsId: itemsDetails,
    address: deliverAddress,
    // paymentType: values.paymentType,
    totalAmount:
      itemsDetails?.length > 0
        ? itemsDetails.reduce(
            (acc, item) => acc + item.quantity * item.sellPrice,
            0
          )
        : 0,
  };
  // console.log(cheokoutData);
  const handleSubmit = async (event) => {
    event.preventDefault();
    for (let key of Object.keys(checkoutData)) {
      if (checkoutData[key] === "") {
        delete checkoutData[key];
      }
    }
    dispatch(createOrder(checkoutData));
    // dispatch(createOrder(orderData, navigateUser));
  };
  const loginUrl = () => {
    navigate(`/login?returnUrl=${locationUrl?.pathname}`);
  };
  return (
    <>
      <div className="app-container">
        <header className="header02">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <a className="navbar-brand" href="/">
                <div className="logo">
                  <span className="logo-text">
                    {" "}
                    <img src={logo} alt="" />
                  </span>
                  <span className="logo-dot"></span>
                </div>
              </a>

              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              {!auth?.user?.id ? (
                <div
                  className="collapse navbar-collapse justify-content-end"
                  id="navbarSupportedContent"
                >
                  {/* <button className="login-button">
                  <LogIn size={18} />
                  <span>Login</span>
                </button> */}
                  <Link
                    to="/login"
                    className="button-21"
                    role="button"
                    style={{
                      marginRight: "45px",
                      color: "#ffffff",
                      backgroundColor: "#28B8EC",
                    }}
                  >
                    <span className="icon-user">
                      <FaRegCircleUser />
                    </span>
                    &nbsp;Login
                  </Link>
                </div>
              ) : (
                <></>
              )}
            </div>
          </nav>
        </header>

        <div className="container-fluid store-detail-page p-0">
          <div
            className="store-header text-center text-white py-4"
            style={{
              backgroundImage: `url(${cover})`,
              backgroundSize: "cover",
            }}
          >
            <h1 className="text-white fw-bold">{arr?.store?.name}</h1>
          </div>
          <div className="container my-4">
            <div className="row g-4" style={{ marginTop: "-100px" }}>
              <div className="col-lg-4">
                <div className="cardNew02 p-4 h-100 shadow-sm">
                  <div className="mb-4">
                    <img
                      src={cover}
                      alt="Artcaffe"
                      className="img-fluid mb-2"
                      style={{ maxWidth: 60 }}
                    />
                    <h4>{arr?.store?.name}</h4>
                    {/* price match {">"} */}
                    <div className="mb-2">
                      <span className="badge bg-light text-dark me-2">
                        🔥 -23% Some items
                      </span>
                      <span className="badge bg-light text-dark">
                        -26% with Prime
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>👍 95%</span>
                      <span>$59.00</span>
                      <span>Prime</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="cardNew02 h-100 p-4 mb-3 store-details-parallel">
                  <div className="row position-relative">
                    {/* Left column - Store Info */}
                    <div className="col-12 col-md-4">
                      <h5 className="">Store information</h5>
                      <p className="mb-1">{arr?.store?.name}</p>
                      <p className="mb-1">
                        <span className="label">Address:</span>{" "}
                        {arr?.store?.storeAddress}
                      </p>
                      <ul className="list-unstyled small open-times">
                        <span className="label">Open times:</span>
                        {arr?.store?.availabilityTime?.map((day) => (
                          <li key={day._id}>
                            <span className="day">{day.dayName}</span>{" "}
                            <span className="time">
                              {day.isOpened
                                ? `${day.openTime} - ${day.closeTime}`
                                : "Closed"}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Right column - Contact + Partner Info */}
                    <div className="col-12 col-md-8 position-relative">
                      {/* Divider for md and up */}
                      <div className="center-divider d-none d-md-block"></div>

                      <div className="contact-box p-2 rounded mb-3">
                        <p className="contact-label fw-bold">Contact</p>
                        <p className="mb-1">
                          <Phone size={14} /> {arr?.store?.phone}
                        </p>
                        <p className="mb-0">
                          <Mail size={14} /> {arr?.store?.email}
                        </p>
                      </div>
                      <div className="partner-info">
                        <p>
                          <h5 className="contact-label fw-bold">
                            Partner information
                          </h5>
                        </p>
                        <p>
                          <span className="label">Legal name:</span>{" "}
                          {arr?.store?.firstName + " " + arr?.store?.lastName}
                        </p>
                        <p>
                          <span className="label">HQ Address:</span>{" "}
                          {arr?.store?.storeAddress}
                        </p>
                        <p>
                          <span className="label">Tax ID:</span>{" "}
                          {arr?.store?.tax ? arr?.store?.tax : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2">
                <div className="sidebar-menu">
                  <h6 className="text-uppercase">Section</h6>
                  <ul className="list-unstyled">
                    <li className="filter-item">Promotions</li>
                    <li className="filter-item">Top Sellers</li>
                    {/* <li className="filter-item">ARTCAFFÉ BUNDLES!</li>
                    <li className="filter-item">COFFEE & PASTRY</li>
                    <li className="filter-item">NEW ARRIVALS</li>
                    <li className="filter-item">BAKERY</li>
                    <li className="filter-item">FRESHLY BAKED CAKES</li> */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3 input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <Search size={16} />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search in Artcaffe"
                  />
                </div>

                <section className="promotion mb-4">
                  <h5 className="fw-bold">Promotion</h5>
                  <div className="card p-3">
                    <div className="d-flex">
                      <img
                        src={defaultimg}
                        // src="/burger.png"
                        alt="burger"
                        className="me-3"
                        style={{
                          width: 70,
                          height: 70,
                          border: "1px solid #ccc", // Light grey border
                          borderRadius: "5px",
                        }}
                      />
                      <div>
                        <h6>
                          Classic Beef Burger{" "}
                          <span className="badge bg-primary">
                            -21% with Drovi Prime
                          </span>
                        </h6>
                        <p className="mb-1 text-muted">
                          Enjoy our juicy beef burger with fresh ingredients and
                          fries.
                        </p>
                        <strong>$29.00</strong>
                      </div>
                    </div>
                  </div>
                </section>

                {/* <section className="top-sellers">
                  <h5 className="fw-bold">🥇 Top sellers</h5>
                  <div className="row">
                    {arr?.allItem?.map((x, i) => (
                      // console.log(x, "xxxxxxxxx"),
                      <div className="col-12 col-lg-6 mb-3" key={i}>
                        <div className="card p-3">
                          <div className="d-flex">
                            <img
                              src={x.itemPic ? x.itemPic.fileUrl : defaultimg}
                              // src={x.itemPic ? x.itemPic : defaultimg}
                              alt="burger"
                              className="me-2"
                              style={{
                                width: 60,
                                height: 60,
                                border: "1px solid #ccc", // Light grey border
                                borderRadius: "5px",
                              }}
                            />
                            <div>
                              <h6 className="mb-1">{x?.name}</h6>
                              <p
                                className="text-muted mb-1"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {x.descriptions
                                  ? x.descriptions
                                  : "Yummy and fresh and ready to service"}
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <strong>${x?.sellPrice}</strong>

                            <div>
                              {!quantities[x?.id] ? (
                                <p
                                  onClick={() =>
                                    increaseQuantity(x?.id, x?.name)
                                  }
                                  style={{ margin: 0, cursor: "pointer" }}
                                >
                                  <CirclePlus color="#28B8EC" size={18} />
                                </p>
                              ) : (
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    onClick={() =>
                                      decreaseQuantity(x?.id, x?.name)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <CircleMinus color="#28B8EC" size={18} />
                                  </span>
                                  <span style={{ fontSize: "14px" }}>
                                    {quantities[x?.id]}
                                  </span>
                                  <span
                                    onClick={() =>
                                      increaseQuantity(x?.id, x?.name)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <CirclePlus color="#28B8EC" size={18} />
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section> */}
                <section className="top-sellers">
                  <h5 className="fw-bold">🥇 Top sellers</h5>
                  <div className="row">
                    {arr?.allItem?.map((x, i) => {
                      const nameWords = x?.name?.split(" ");
                      const displayName =
                        nameWords?.length > 16
                          ? nameWords.slice(0, 16).join(" ") + "..."
                          : x?.name;

                      const descText = x?.descriptions
                        ? x.descriptions.length > 35
                          ? x.descriptions.slice(0, 35) + "..."
                          : x.descriptions
                        : "-";

                      return (
                        <div className="col-12 col-lg-6 mb-3" key={i}>
                          <div className="card p-3 h-90">
                            <div className="d-flex">
                              <img
                                src={x.itemPic ? x.itemPic.fileUrl : defaultimg}
                                alt="item"
                                className="me-2"
                                style={{
                                  width: 60,
                                  height: 60,
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                  objectFit: "cover",
                                  flexShrink: 0,
                                }}
                              />
                              <div style={{ flex: 1 }}>
                                <h6
                                  className="mb-1"
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {displayName}
                                </h6>
                                <p
                                  className="text-muted mb-1"
                                  style={{
                                    fontSize: "0.85rem",
                                    minHeight: "1.2rem", // Ensure height is consistent even if empty
                                    marginBottom: "0.5rem",
                                  }}
                                >
                                  {descText}
                                </p>
                              </div>
                            </div>
                            <div
                              className="mt-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <strong>${x?.sellPrice}</strong>
                              <div>
                                {!quantities[x?.id] ? (
                                  <p
                                    onClick={() =>
                                      increaseQuantity(x?.id, x?.name)
                                    }
                                    style={{ margin: 0, cursor: "pointer" }}
                                  >
                                    <CirclePlus color="#28B8EC" size={18} />
                                  </p>
                                ) : (
                                  <div className="d-flex align-items-center gap-2">
                                    <span
                                      onClick={() =>
                                        decreaseQuantity(x?.id, x?.name)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <CircleMinus color="#28B8EC" size={18} />
                                    </span>
                                    <span style={{ fontSize: "14px" }}>
                                      {quantities[x?.id]}
                                    </span>
                                    <span
                                      onClick={() =>
                                        increaseQuantity(x?.id, x?.name)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <CirclePlus color="#28B8EC" size={18} />
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </section>
              </div>

              {itemsDetails && itemsDetails.length > 0 ? (
                <div className="col-lg-4">
                  <form id="checkout-form" onSubmit={handleSubmit}>
                    <div className="card p-3 mt-3">
                      <h4 className="fw-bold text-center">Your order</h4>
                      {itemsDetails.map((item) => (
                        <div key={item.id}>
                          <div className="d-flex justify-content-between mb-2">
                            <span>
                              <strong>{item.quantity}x</strong> {item.name}
                            </span>
                            <strong>
                              ${" "}
                              {(
                                item.quantity * item.sellPrice
                              ).toLocaleString()}
                            </strong>
                          </div>
                          <div
                            className="d-flex"
                            style={{
                              justifyContent: "space-between",
                              marginTop: "-10px",
                            }}
                          >
                            <p
                              onClick={() =>
                                decreaseQuantity(item?.itemId, item?.name)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <CircleMinus color="#28B8EC" size={18} />
                            </p>
                            <p
                              onClick={() =>
                                increaseQuantity(item?.itemId, item?.name)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <CirclePlus color="#28B8EC" size={18} />
                            </p>
                          </div>
                        </div>
                      ))}

                      <div className="text-center mt-3">
                        {!values.userId ? (
                          <>
                            <button
                              className="btn btn-primary w-100"
                              style={{
                                borderRadius: "25px",
                              }}
                              onClick={loginUrl}
                            >
                              Please Login/Sign Up to Continue
                            </button>
                          </>
                        ) : (
                          <>
                            <SearchedByMap
                              values={values}
                              setValues={setValues}
                              searchAddress={values?.address?.address}
                              reduceButton={true}
                            />
                            <button
                              className="btn btn-primary w-100"
                              style={{
                                borderRadius: "25px",
                              }}
                              disabled={
                                !values.userId || !values?.address?.address
                              }
                            >
                              {/* Order{" "}
                        {itemsDetails.reduce((acc, i) => acc + i.quantity, 0)}{" "}
                        for $ {item.totalAmount} */}
                              Order{" "}
                              {itemsDetails.reduce(
                                (acc, i) => acc + i.quantity,
                                0
                              )}{" "}
                              for ${" "}
                              {itemsDetails
                                .reduce(
                                  (acc, item) =>
                                    acc + item.quantity * item.sellPrice,
                                  0
                                )
                                .toLocaleString()}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="col-lg-4">
                  <div className="card p-3 mt-3 text-center">
                    <h4 className="fw-bold ">Your order</h4>
                    <img
                      src={noOrderImg}
                      alt="No items"
                      style={{ width: "100px", marginBottom: "15px" }}
                    />
                    <p className="text-center">
                      You've not added any products yet. When you do, you'll see
                      them here!
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="">
          <div class="curve-wrapper" style={{ marginBottom: "-1px" }}>
            <svg viewBox="0 0 1440 100" class="top-curve">
              <path
                d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
                fill="#000"
              />
            </svg>
          </div>
          {/* <div className="footer-arch-top"></div> */}
          <footer>
            <h3
              style={{
                display: "flex",
              }}
            >
              <a className="navbar-brand" href="#">
                <img
                  src={footerlogo}
                  alt="Logo"
                  id="logsedf"
                  style={{ width: "52%" }}
                />
              </a>
            </h3>
            <div className="footer-container">
              <div className="footer-column">
                {/* <h3>Let’s do it together</h3> */}
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Let’s do it together
                    </a>
                  </li>
                  <li>
                    <a href="#">Career</a>
                  </li>
                  <li>
                    <a href="#">Partner</a>
                  </li>
                  <li>
                    <a href="#">Couriers</a>
                  </li>
                  <li>
                    <a href="#">Business</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Link of Interest
                    </a>
                  </li>
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li>
                    <a href="#">FAQs</a>
                  </li>
                  <li>
                    <a href="#">Drovi Prime</a>
                  </li>
                  <li>
                    <a href="#">Blog</a>
                  </li>
                  <li>
                    <a href="#">Contact Us</a>
                  </li>
                  <li>
                    <a href="#">Security</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Follow us
                    </a>
                  </li>
                  <li>
                    <a href="#">Facebook</a>
                  </li>
                  <li>
                    <a href="#">Twitter</a>
                  </li>
                  <li>
                    <a href="#">Instagram</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <div className="app-icons">
                  <ul>
                    <li>
                      <a href="#">
                        <img src={googlee} alt="Google Play" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <img src={applee} alt="App Store" />
                      </a>
                    </li>
                    <li>
                      <a href="#">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Cookies Policy</a>
                    </li>
                    <li>
                      <a href="#">Compilance</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p>All Rights Reserved. Iconictek Company © 2024</p>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default HomeStopDetails;
